const ACTIVE_COMPANY_KEY = 'crmActiveCompanyId';

export function readStoredActiveCompanyId() {
  try {
    return localStorage.getItem(ACTIVE_COMPANY_KEY) || '';
  } catch {
    return '';
  }
}

export function writeStoredActiveCompanyId(id) {
  try {
    if (id) localStorage.setItem(ACTIVE_COMPANY_KEY, String(id));
    else localStorage.removeItem(ACTIVE_COMPANY_KEY);
  } catch {
    /* ignore */
  }
}

export function clearStoredActiveCompanyId() {
  writeStoredActiveCompanyId('');
}
